import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * ProGate — замок «🔒 Доступно в Pro» для платного функционала.
 *
 * Если тариф пользователя не даёт фичу (см. backend/app/services/entitlements.py:
 * advanced_stats, export, school_team, payments_advanced, automation) — вместо
 * children показывается карточка с предложением открыть тарифы.
 *
 * ⚠️ Это только UI. Бэкенд проверяет доступ на каждом write-эндпоинте
 * (ЭТАП 6) — замок ничего не «открывает», а лишь честно показывает,
 * что функция платная.
 */
export default function ProGate({ feature, title, description, children }: {
  feature: string;
  title?: string;
  description?: string;
  children?: ReactNode;
}) {
  const { canUseFeature } = useAuth();
  const navigate = useNavigate();

  if (canUseFeature(feature)) return <>{children}</>;

  return (
    <div className="p-4 animate-fade-in">
      <div className="tg-card flex flex-col items-center py-10 px-6 text-center">
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[var(--tg-theme-button-color)] to-purple-600 flex items-center justify-center text-2xl mb-3 shadow-md">
          🔒
        </div>
        <h3 className="text-base font-bold text-[var(--tg-theme-text-color)] mb-1">
          {title || 'Доступно в Pro'}
        </h3>
        <p className="text-xs text-[var(--tg-theme-hint-color)] leading-relaxed mb-5">
          {description || 'Эта возможность входит в платный тариф.'}
        </p>
        <button
          onClick={() => navigate('/billing')}
          className="w-full py-2.5 rounded-xl bg-gradient-to-r from-[var(--tg-theme-button-color)] to-purple-600 text-[var(--tg-theme-button-text-color)] font-semibold text-sm transition-all hover:opacity-90 active:scale-[0.98] flex items-center justify-center gap-1.5"
        >
          ⭐ Открыть тарифы
        </button>
      </div>
    </div>
  );
}
